// import { modifyPointCloud } from "api/timeline";
// import { getPointCloudData } from "pages/unity/domain/getPointCloudData";
// import { getPointCloudbyId } from "api/timeline";
// import { deletePointCloud, refreshProcessing, getProjectDatesInfo, rerunProcessing } from "api/pointCloud";
import colorDropdownConfig from "./colorDropdownConfig";

const projectDateConfig = {
  getPointCloudData: () => null,
  deletePointCloud: () => null,
  modifyPointCloud: () => null,
  colorDropdownConfig,
  refreshProcessing: () => null,
  getPointCloudbyId: () => null,
  getProjectDatesInfo: () => null,
  rerunProcessing: () => null
};

export default projectDateConfig;